import { Component, Input, Injector, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'app-device-info-menu',
    templateUrl: './device-info-menu.component.html',
    styleUrls: ['./device-info-menu.component.css'],
    standalone: false
})
export class DeviceInfoMenuComponent {
  @Input() mapMode: boolean = false;
}
